import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import {
  GroupedSessions,
  groupSessionsByDate,
} from "../../utils/dateExtensions";
import { MAX_DISPLAYED_SESSIONS } from "../constants/sessionConstants";

/**
 * Selector to get recently completed sessions from state
 */
export const selectRecentlyCompletedSessions = (state: RootState) =>
  state.sessions.recentlyCompletedSessionsState.recentlyCompletedSessions;

/**
 * Selector to get recently completed sessions loading status
 */
export const selectRecentlyCompletedSessionsStatus = (state: RootState) =>
  state.sessions.recentlyCompletedSessionsState.loadingStatus;

/**
 * Selector to get recently completed sessions initialization status
 */
export const selectRecentlyCompletedSessionsInitializationStatus = (
  state: RootState
) => state.sessions.recentlyCompletedSessionsState.initializationStatus;

/**
 * Selector to get recently completed sessions grouped by date, limited to MAX_DISPLAYED_SESSIONS sessions
 */
export const selectRecentlyCompletedSessionsGroupedByDate = createSelector(
  [selectRecentlyCompletedSessions],
  (recentlyCompletedSessions): GroupedSessions[] => {
    return groupSessionsByDate(
      recentlyCompletedSessions,
      MAX_DISPLAYED_SESSIONS, // maxSessions
      "desc" // sortOrder - most recent first for completed sessions
    );
  }
);

/**
 * Selector to check if there are any recently completed sessions
 */
export const selectHasRecentlyCompletedSessions = createSelector(
  [selectRecentlyCompletedSessions],
  (recentlyCompletedSessions): boolean => recentlyCompletedSessions.length > 0
);

/**
 * Selector to get the count of recently completed sessions
 */
export const selectRecentlyCompletedSessionsCount = createSelector(
  [selectRecentlyCompletedSessions],
  (recentlyCompletedSessions): number => recentlyCompletedSessions.length
);
